import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center">
        <div className="text-[clamp(6rem,20vw,14rem)] font-bold font-space tracking-tighter leading-none">
          404<span className="text-primary">.</span>
        </div>
        <div className="text-muted-foreground uppercase tracking-widest text-sm mb-8">
          PAGE NOT FOUND
        </div>
        <Link
          to="/"
          className="inline-block bg-primary text-black px-8 py-4 font-bold uppercase tracking-widest hover:bg-white"
        >
          返回首页
        </Link>
      </div>
    </div>
  );
}
